import { useState } from "react";
import PaymentsByYearTable from "./PaymentsByYearTable";
import PaymentsByYearHeader from "./PaymentsByYearHeader";

const PaymentsByYearScreen = ({years, selectedYear, setSelectedYear, setSelectPeriod}) => {
  return (
    <div>
      <PaymentsByYearHeader years={years} selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
      <PaymentsByYearTable selectedYear={selectedYear} setSelectPeriod={setSelectPeriod}/>
    </div>
  );
}

export default PaymentsByYearScreen;